import { Schema } from 'effect';
import { SiteId } from './common.js';
/**
 * DTO schemas for the /auth email flows.
 *
 * Bodies are decoded loosely (optional/`unknown`) because each field has its own
 * translated 400 — `isPlausibleUrl`, "same address", "not a password user" —
 * which a single decode failure can't express. Schema owns the shape, the
 * handler owns the semantics via `HttpProblem`.
 */
export const SiteParams = Schema.Struct({ site: SiteId });
export const ContinueUrlBody = Schema.Struct({
    continueUrl: Schema.optional(Schema.Unknown)
});
export const ChangeEmailBody = Schema.Struct({
    newEmail: Schema.optional(Schema.Unknown),
    continueUrl: Schema.optional(Schema.Unknown)
});
export const SendResetBody = Schema.Struct({
    email: Schema.optional(Schema.Unknown),
    continueUrl: Schema.optional(Schema.Unknown)
});
export const ConfirmProfileBody = Schema.Struct({
    token: Schema.optional(Schema.Unknown)
});
/** `{ sent: true }` or the `{ sent: false, alreadyVerified: true }` short circuit. */
export const SentResponse = Schema.Struct({
    sent: Schema.Boolean,
    alreadyVerified: Schema.optional(Schema.Boolean)
});
export const VerifiedResponse = Schema.Struct({ verified: Schema.Boolean });
export const PolicyResponse = Schema.Struct({
    emailVerification: Schema.Struct({
        enforcement: Schema.String,
        cutoffISO: Schema.String
    }),
    passkeys: Schema.Struct({ enabled: Schema.Boolean }),
    mfa: Schema.Struct({ enabled: Schema.Boolean })
});
//# sourceMappingURL=auth.js.map